import { deCryptFun } from "./CustomFunction";

export function authHeader() {
  const token = localStorage.getItem("AUTH_TOKEN");
  return { Authorization: token ? token : null };
}

export function getHamburgerMenu() {
  const userId = localStorage.getItem("HamburgerMenu");
  const userId2 = userId ? deCryptFun(userId) : "";
  return userId2;
}

export function getLogUserId(){
let luid = localStorage.getItem("LOG_USER_ID");
let id= deCryptFun(luid)
  return id
}

export function getLogUserRole(){
  let r = localStorage.getItem("ROLE");
  let roles = r ? deCryptFun(r) : [];
  return roles;
}
export function getLogUserRole1(){
  const encryptedRoles = localStorage.getItem("ROLE");
  if (encryptedRoles) {
    return deCryptFun(encryptedRoles); // Make sure this returns an array of strings
  }
  return [];
};

// export function getLogUserRole() {
//   const encryptedRole = localStorage.getItem("ROLE");
//   let r = encryptedRole ? deCryptFun(encryptedRole) : null;

//   // Ensure `r` is an array or fallback to an empty array
//   let roles = Array.isArray(r) ? r : [];
//   return roles;
// }

// export function getLogUserRole1() {
//   const encryptedRoles = localStorage.getItem("ROLE");

//   if (encryptedRoles) {
//     const decrypted = deCryptFun(encryptedRoles);
//     return Array.isArray(decrypted) ? decrypted : []; // Return array if valid, otherwise empty array
//   }
//   return [];
// }

export function getLogUserName() {
  let r = deCryptFun(localStorage.getItem("LOG_USER_NAME"));
  let roles = r ? r :'';
  return roles;
}

export function getLogEmail() {
  let luemail = localStorage.getItem("LOG_USER_EMAIL");
  if (!luemail) return undefined;
  return deCryptFun(luemail);
}


export function getLogRoleId() {
  let lurole = localStorage.getItem("LOG_USER_ROLE");
let role= deCryptFun(lurole)
  return role;
}
export function getStatementId(){ 
  let invid = localStorage.getItem('BILLING_STATEMENT_ID')
  const iid = invid ? parseInt(deCryptFun(invid)) : "";
  return iid;
}
export function getSideIndex(){ 
  let invid = localStorage.getItem('LOG_SIDE_INDEX')
  const iid = invid ? invid : "";
  return iid;
}
function descendingComparator(a, b, orderBy) {
  //let dateInclude = ['zDueDateFormat']
  let valueA
  if (Number.isInteger(a[orderBy])) {
    valueA = a[orderBy]
  } else {
    valueA = a[orderBy]?.toLowerCase()
  }
  let valueB
  if (Number.isInteger(b[orderBy])) {
    valueB = b[orderBy]
  } else {
    valueB = b[orderBy]?.toLowerCase()
  }
  if (valueB < valueA) {
    return -1
  }
  if (valueB > valueA) {
    return 1
  }
  return 0
}
export function getComparator(order, orderBy) {
  console.log(order, orderBy, 'by')
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}
export function stableSort(array, comparator) {
  console.log('comparator', comparator)
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  console.log(stabilizedThis.map((el) => el[0]))
  return stabilizedThis.map((el) => el[0])
}